import React from 'react'
import BotonesSumayResta from './pedidoPos/BotonesSumayResta'
import { NumericFormat } from 'react-number-format';

const PedidoPos = ({ pedido, onClickSuma, onClickResta, onClickElimina, onClickModalProd }) => {

	const verNombresAtributos = (atributos, combo) => {
		let nombre = "";

		atributos.map((atri, index) => {
			nombre += combo === "true" && atri.atributos && atri.opciones ? `(x${atri.cantidad}) ${atri.producto?.nombre_producto}: ${atri.opciones.padre}: ${atri.opciones.nombre},` : !atri.atributos && !atri.opciones && atri.producto ? `(x${atri.cantidad}) ${atri.producto?.nombre_producto}` : `${atri.categoria}: ${atri.atributo.opcion}`
		})
		//trae los primeros 20 caracteres
		return nombre
	}


	return (
		<div className="contCardsPedido">

			{pedido.map((producto, index) => {
				const validarSiExisteAtributos = producto.atributos.length > 0
				const esPar = (index % 2 == 1)

				return (
					<div className={`${esPar ? 'CardpedidoPar' : ''} CardPedido`} key={index}>
						<div className="row">
							<button onClick={onClickModalProd(producto)} className="col-md-4 col-5 infoCardPedido btnDetalle">
								<h5>{producto.nombre_producto}</h5>
								<div style={{maxHeight: 50, overflowY: 'hidden'}}>
									{validarSiExisteAtributos ? <p>{verNombresAtributos(producto.atributos, producto.combo)}</p> : null}
								</div>
								{producto.precio_rebajado > 0 ?
									<div>
										<NumericFormat value={producto.precio_producto} className="tachado" displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
										<NumericFormat value={producto.precio_rebajado} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
									</div>
									: <NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
								}
							</button>
							<div className="col-md-8 col-7 contBotones">
								<BotonesSumayResta
									index={index}
									onClickSuma={onClickSuma}
									onClickResta={onClickResta}
									onClickElimina={onClickElimina}
									cantidad={producto.cantidad_producto}
									inventario={producto.inventario}
								/>
							</div>
						</div>
					</div>
				)
			})}
		</div>
	);



}



export default PedidoPos